import React, { useEffect } from 'react';
import './FloatingLabelTextarea.css';

//   ** Example **
// Needs to be wrapped by InputGroup (react-bootstrap)
// <InputGroup>
//     <FloatingLabelTextarea state={firstName} setState={setFirstName} id='first-name' label='First Name' />
// </InputGroup>
// Require: state, setState, id, label
// Optional: disabled, style

export default function FloatingLabelTextarea(props) {

    const { state, setState, id, label, disabled, style, maxLength, placeholder } = props;

    useEffect(() => {
        const label = document.querySelector(`[for=${id}]`);
        state?.length > 0 ? label.classList.add('flt-float') : label.classList.remove('flt-float');
    }, [state, id])

    return (
        <>
        <textarea
            id={id} 
            className='flt-input' 
            value={state} 
            onChange={(e) => setState(e.target.value)}
            maxLength={maxLength ? maxLength : null}
            placeholder={placeholder ? placeholder : null}
            style={style ? style : null}
            disabled={disabled ? disabled : false}
        />
        <label htmlFor={id} className='flt-label'>{label}</label>
        </>
    );
};